import { Component } from '@angular/core';
import {
  ArgosModalConfig,
  ArgosModalRef
} from '@core-argos-angular-artifact/components';
import { QuestionType } from '../../../core/enum/survey.enum';
import {
  IBlock,
  IQuestion,
  ISurvey,
  SurveyChoice,
  SurveyError
} from '../../../core/interfaces/survey.interface';

export interface SurveyModalData {
  title: string;
  survey?: ISurvey | SurveyError;
}

@Component({
  selector: 'my-account-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss']
})
export class SurveyComponent {
  data: SurveyModalData;
  title: string;
  survey: ISurvey | SurveyError;
  blocks: IBlock[];
  blockIndex = 0;
  questionIndex = 0;
  responses: any;
  userResponse = '';
  btnDisabled = false;
  hiddenTextArea = false;
  enumQuestionType = QuestionType;

  constructor(
    public dialogRef: ArgosModalRef,
    private readonly modalConfig: ArgosModalConfig
  ) {
    this.data = modalConfig.data;

    this.title = this.data.title;
    this.survey = this.data.survey;
    this.blocks = this.data.survey['blocks'] || [];
    this.responses = this.data.survey['responses'];
    this.btnDisabled = this.getRequiredQuestionNoAnswer();
    this.findDependencies();
  }

  onChoiceChange(evt: any, choice: SurveyChoice, questionId: string): void {
    this.responses[questionId].response = evt.target['checked']
      ? choice.id
      : '';
    this.userResponse = '';
    this.btnDisabled = this.getRequiredQuestionNoAnswer();
  }

  dismiss(): boolean {
    const currentChoice = this.setCurrentChoice();
    if (currentChoice && currentChoice['dep']) {
      const depQuestion = currentChoice['dep'].questionID;
      this.responses[depQuestion].response = this.userResponse;
    }
    const answer = {
      responses: this.responses,
      surveyId: this.survey['surveyID'],
      language: this.survey['language']
    };
    this.dialogRef.close(answer);
    return true;
  }

  private getRequiredQuestionNoAnswer(): boolean {
    const requiredQuestionNoAnswer = this.blocks.find(
      (block: IBlock) =>
        !!block.questions.find(
          (question: IQuestion) =>
            question.validator.required &&
            this.responses[question.questionID].response === ''
        )
    );
    return !!requiredQuestionNoAnswer;
  }

  private findQuestion(id: string): IQuestion {
    let found;
    this.blocks.forEach((block: IBlock) => {
      found = block.questions.find(q => q.questionID === id);
    });
    return found;
  }

  private assignDependencie(question) {
    question.dependencies.forEach(dependencie => {
      const depQuestion = this.findQuestion(dependencie.questionID);
      question.choices.forEach(choice => {
        if (
          depQuestion['displayLogic'][0].questionReferenceID ===
            question.questionID &&
          depQuestion['displayLogic'][0].response === choice.id
        ) {
          choice['dep'] = depQuestion;
        }
      });
    });
  }

  private findDependencies() {
    this.blocks.forEach(block => {
      if (block.questions) {
        block.questions.forEach(question => {
          if (question.dependencies) {
            this.assignDependencie(question);
          }
        });
      }
    });
  }

  private setCurrentChoice() {
    const currentQuestion =
      this.blocks[this.blockIndex].questions[this.questionIndex];
    const mainResponse = this.responses[currentQuestion.questionID].response;
    const currentChoice = currentQuestion.choices.find(
      choice => choice.id === mainResponse
    );
    return currentChoice;
  }
}
